import { render, staticRenderFns } from "./QualityBreakdownCard.vue?vue&type=template&id=04b6755c&scoped=true&"
import script from "./QualityBreakdownCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./QualityBreakdownCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./QualityBreakdownCard.vue?vue&type=style&index=0&id=04b6755c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6755c",
  null
  
)

export default component.exports